import AddressCard from "pages/VehicleImporterPages/ImporterDetailsModal/AddressCard"
import DataCard from "components/Common/DataCard"
import ThumbnailImage from "components/Common/ThumbnailImage"
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap"

export default function ImporterDetailsModal({ modal, toggle, importer }) {
  if (!importer) return null

  // Helper to handle null/undefined/empty values
  const safeValue = val => {
    if (!val || (Array.isArray(val) && val.length === 0)) return "N/A"
    return val
  }

  // Prepare data for DataCard
  const generalInfo = [
    { label: "Name", value: safeValue(importer.name) },
    { label: "Email", value: safeValue(importer.email) },
    { label: "Website", value: safeValue(importer.website) },
  ]

  const mobileNumbers = (importer.mobile || []).map((m, i) => ({
    label: `Mobile ${i + 1}`,
    value: safeValue(m),
  }))

  const authorizedPersons = (importer.staff || []).map((person, i) => ({
    label: `${safeValue(person.name)} (${safeValue(person.designation)})`,
    value: Array.isArray(person.mobile) && person.mobile.length
      ? person.mobile.map(m => safeValue(m)).join(", ")
      : "N/A",
  }))

  const addresses = (importer.address || []).map((addr, i) => ({
    label: safeValue(addr.showroom_name) || `Address ${i + 1}`,
    value: `
      ${safeValue(addr.showroom_address)},
      ${safeValue(addr.address)},
      Mobile: ${safeValue(addr.mobile)},
      Email: ${safeValue(addr.email)}
    `,
  }))

  return (
    <Modal isOpen={modal} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>Vehicle Importer Details</ModalHeader>
      <ModalBody>
        <Row className="mb-3">
          <Col md={12} className="text-center">
            <ThumbnailImage
              className="border shadow-lg"
              size="lg"
              primaryImage={importer.logo?.[0]?.url || ""}
              alt="Importer Logo"
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <DataCard title="General Information" data={generalInfo} />
          </Col>
          <Col md={6}>
            <DataCard
              title="Mobile Numbers"
              data={
                mobileNumbers.length
                  ? mobileNumbers
                  : [{ label: "Mobile", value: "N/A" }]
              }
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <DataCard
              title="Authorized Persons"
              data={
                authorizedPersons.length
                  ? authorizedPersons
                  : [{ label: "Authorized Person", value: "N/A" }]
              }
            />
          </Col>
          <Col md={6}>
           <AddressCard addresses={importer.address || []} />
          </Col>
          
            
        </Row>
      </ModalBody>
    </Modal>
  )
}
